import {Nullable, OfferFreeBadges} from 'common/types';
import {
  CommonAction,
  FETCH_OFFER_FREE_BADGES_FAILURE,
  FETCH_OFFER_FREE_BADGES_REQUEST,
  FETCH_OFFER_FREE_BADGES_SUCCESS,
} from '../types';

interface State {
  data: Nullable<OfferFreeBadges>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  data: null,
  isFetching: false,
  error: null,
};

export const offerFreeBadgesReducer = (
  state: State = initialState,
  action: CommonAction
) => {
  switch (action.type) {
    case FETCH_OFFER_FREE_BADGES_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      };

    case FETCH_OFFER_FREE_BADGES_SUCCESS:
      return {
        ...state,
        data: action.payload.offerFreeBadges,
        isFetching: false,
      };

    case FETCH_OFFER_FREE_BADGES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
